export class SelectScroller {
    private readonly scrollable;
    private isVisible;
    private observer;

    constructor (scrollable: Node) {
        this.scrollable = scrollable;
        this.isVisible = false;
    }

    observe () {
        if (this.observer) {
            return;
        }
        this.observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                const target = mutation.target as HTMLElement;
                const isVisible = target.parentElement.classList.contains('is-visible');

                if (!this.isVisible && isVisible) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    $(this.scrollable).scrollInsteadOf(window);
                    this.isVisible = true;
                } else if (this.isVisible && !isVisible) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    $(this.scrollable).scrollInsteadOf(false);
                    this.isVisible = false;
                }
            });
        });
        this.observer.observe(this.scrollable as Node, {
            attributes: true,
            attributeFilter: ['class'],
            childList: false,
            characterData: false,
            attributeOldValue: true
        });
    }

    destroy () {
        if (!this.observer) {
            return;
        }
        this.observer.disconnect();
        this.observer = null;
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        $(this.scrollable).scrollInsteadOf(false);
    }
}
